<template>
  <div class="GemeosSV">
    <div class="form-group px-2 ml-2">
      <div class="d-inline-block w-100">
        <label class="label"
               for="confirmGemeosSim">Possui Gêmeos?</label>
      </div>
      <span class="custom-control custom-radio custom-control-inline">
        <input id="confirmGemeosSim"
               v-model="possuiGemeos"
               class="custom-control-input input-gemeos"
               checked
               name="confirmGemeos"
               type="radio"
               :value="1"
               @change="(event) => updateFlag(event.target.value)">
        <label class="custom-control-label"
               for="confirmGemeosSim">Sim</label>
      </span>

      <span class="custom-control custom-radio custom-control-inline">
        <input id="confirmGemeosNao"
               v-model="possuiGemeos"
               class="custom-control-input input-gemeos"
               name="confirmGemeos"
               type="radio"
               :value="0"
               @change="(event) => updateFlag(event.target.value)">
        <label class="custom-control-label"
               for="confirmGemeosNao">Não</label>
      </span>
    </div>
    <div v-if="possuiGemeos">
      <div class="row mb-3 ml-1">
        <div class="col-12">
          <label class="label"
                 for="ordem_nascimento_registrado">
            Ordem de Nascimento do Registrado
          </label>
        </div>
        <div class="col-2">
          <input id="ordem_nascimento_registrado"
                 v-model="ordem_nascimento"
                 v-validate="'min:1'"
                 :min="1"
                 name="ordem_nascimento_registrado"
                 :class="{ 'is-invalid': errors.has('ordem_nascimento_registrado') || verifyOrdem(ordem_nascimento, null, true)}"               
                 type="number"
                 class="form-control form-control-sm"
                 @change="event => updateOrdemNascimento(event.target.value)">
          <small v-if="errors.has('ordem_nascimento_registrado')"
                 class="invalid-feedback">{{ errors.first('ordem_nascimento_registrado') }}</small>
          <small v-else-if="verifyOrdem(ordem_nascimento, null, true)"
                 class="invalid-feedback">Ordem de nascimento já cadastrada.</small>
        </div>
      </div>
      <div v-for="(gemeo, index) in propPessoa.gemeos"
           :key="index"
           class="row px-3">
        <div class="col-12 GemeosSV_title mb-3 d-flex justify-content-between align-items-center px-3">
          <label for=""
                 class="label">
            Gêmeo - {{ index + 1 }}
          </label>
          <button class="btn btn-sm btn-danger mb-2"
                  @click="removeGemeo(index)">
            Excluir
          </button>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label class="label"
                   :for="`ordem_nascimento_gemeo_${index}`">
              Ordem Nasc.
            </label>
            <input :id="`ordem_nascimento_gemeo_${index}`"
                   v-model="gemeo.ordem_nascimento"
                   v-validate="'min:1'"
                   :min="1"
                   :name="`ordem_nascimento_gemeo_${index}`"
                   :class="{ 'is-invalid': errors.has(`ordem_nascimento_gemeo_${index}`) || verifyOrdem(gemeo.ordem_nascimento, index, false) }"               
                   type="number"
                   class="form-control form-control-sm">
            <small v-if="errors.has(`ordem_nascimento_gemeo_${index}`)"
                   class="invalid-feedback">{{ errors.first(`ordem_nascimento_gemeo_${index}`) }}</small>
            <small v-if="verifyOrdem(gemeo.ordem_nascimento, index, false)"
                   class="invalid-feedback">Ordem de nascimento já cadastrada</small>
          </div>
        </div>
        <div class="col-7">
          <div class="form-group">
            <label class="label"
                   :for="`nome_gemeo_${index}`">
              Nome
            </label>
            <input :id="`nome_gemeo_${index}`"
                   v-model="gemeo.nome"
                   v-validate="'required'"
                   name="nome_gemeo"
                   :class="{ 'is-invalid': errors.has(`nome_gemeo_${index}`) }"               
                   type="text"
                   class="form-control form-control-sm">
            <small v-if="errors.has(`nome_gemeo_${index}`)"
                   class="invalid-feedback">{{ errors.first(`nome_gemeo_${index}`) }}</small>
          </div>
        </div>
        <div class="col-3">
          <div class="form group">
            <label :for="`sexo_gemeo_${index}`"
                   class="label">Sexo</label>
            <select :id="`sexo_gemeo_${index}`"
                    v-model="gemeo.sexo"
                    class="custom-select custom-select-sm"
                    :name="`sexo_gemeo_${index}`">
              <option selected
                      value="">
                Selecione
              </option>
              <option v-for="sexo in SEXOS"
                      :key="sexo.value"
                      :value="sexo.value">
                {{ sexo.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label class="label"
                   :for="`dnv_gemeo_${index}`">
              Nº Declaração de Nascido Vivo
            </label>
            <input :id="`dnv_gemeo_${index}`"
                   v-model="gemeo.numero_declaracao_nascido_vivo"
                   :name="`dnv_gemeo_${index}`"
                   :class="{ 'is-invalid': errors.has(`dnv_gemeo_${index}`) }"               
                   type="text"
                   class="form-control form-control-sm">
          </div>
        </div>
        <div class="col-7">
          <div class="form-group">
            <label class="label"
                   :for="`matricula_gemeo_${index}`">
              Matrícula
            </label>
            <input :id="`matricula_gemeo_${index}`"
                   v-model="gemeo.matricula"
                   v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                   :name="`matricula_gemeo_${index}`"
                   :class="{ 'is-invalid': errors.has(`matricula_gemeo_${index}`) }"               
                   type="text"
                   class="form-control form-control-sm">
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 px-4">
          <button class="btn btn-sm btn-outline-primary btn-block btn-add-gemeo"
                  type="button"
                  @click="addGemeo()">
            <IconSvg class="icon-add mr-1"
                     icon="add" />
            Adicionar gêmeo
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* constants */
  import SEXOS from '@/constants/sexos'

  export default {
    name: 'GemeosSV',
    props: {
      propPessoa: { type: Object, default: () => ({}) },
      propOrdemNascimento: { type: Number, default: null}
    },
    data () {
      return {
        SEXOS,
        possuiGemeos: 0,
        ordem_nascimento: null
      }
    },
    watch: {
      propPessoa () {
        if ((this.propPessoa.gemeos && this.propPessoa.gemeos.length) || this.propPessoa.possui_gemeos_crc) {
          this.possuiGemeos = 1
        }
      },
      propOrdemNascimento () {
        this.ordem_nascimento = this.propOrdemNascimento
      }
    },
    methods: {
      addGemeo () {
        this.propPessoa.gemeos.push({})
      },
      removeGemeo (index) {
        this.$emit('removeGemeo', index)
      },
      updateFlag (value) {
        value = parseInt(value, 10)

        if (this.propPessoa.possui_gemeos_crc) {
          this.$emit('updateFlag', value)
        }

        if (!value && this.propPessoa.gemeos && this.propPessoa.gemeos.length) {
          this.propPessoa.gemeos.forEach(() => {
            setTimeout(() => {
              this.removeGemeo(0)
            })
          })
        }
      },
      verifyOrdem (ordemNascimento, indexForm, nascido) {
        if (ordemNascimento) ordemNascimento = parseInt(ordemNascimento, 10)

        const duplicado = this.propPessoa.gemeos.find((gemeo, index) => {
          return (ordemNascimento == gemeo.ordem_nascimento && index != indexForm) || (ordemNascimento === this.ordem_nascimento && !nascido)
        })

        return !!duplicado
      },
      updateOrdemNascimento (ordem) {
        if (ordem) ordem = parseInt(ordem, 10)

        this.$emit('updateOrdemNascimento', ordem)
      }
    }
  }
</script>

<style lang="scss">
  .GemeosSV {
    &_title {
      border-bottom: 1px solid #858585 ;
    }
  }

  .btn-add-gemeo:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>